<template>
  <v-card class="pa-4" flat id="uploadCenter">
    <v-container>
      <WidgetDevice :adminView='true' ref="wd" :startDevice="device" :startCompanyGuid="companyId"></WidgetDevice>
    </v-container>
  </v-card>
</template>

<script>
import Vue from 'vue'
import WidgetDevice from "../../widgets/WidgetDevice";

export default {
  name: 'TabPreview',
  props:['device', 'companyId'],
  components: {WidgetDevice},
  methods: {
    onGetData: function (data) {
      console.log('deviceGuid', data)
      if (data.tags === null) {
        data.tags = '[]'
      }
      data.tags = JSON.parse(data.tags)

      if (data.guidCompany) {
        Vue.prototype.$apiCompany.loadCompany(data.guidCompany, this.onGetCompany)
      }
      if (data.guidPlaylist) {
        Vue.prototype.$api.loadPlayList(data.guidPlaylist, this.onGetPlaylist)
      }
      this.formData = data
    },
    onItemUpdated: function (data) {
      console.log('onItemUpdated', data)
    },
    onEnterTag: function () {
      this.formData.tags.push(this.$refs.acFields.internalSearch)
    },
    cancelItem: function () {
      this.$router.push('/Dashboard/Netzwerke')
    },
    updateItem: function () {
      Vue.prototype.$api.updateDevice(this.deviceGuid, this.formData, this.onItemUpdated)
    },
    getLabelCompany: function () {
      if (this.company) {
        return 'Netzwerk gewählt ' + this.company.name
      }
      return 'Netzwerk zuweisen'
    },
    getBackgroundImageUrl: function (item) {
      var url = Vue.prototype.$config.HOST + '/media/devices/' + this.deviceGuid + '/' + item.imgBackground
      return url
    },
    editPlaylist: function () {
      console.log('showLink')
      this.$router.push('/Playlist/' + this.formData.guidPlaylist)
    },
    showLink: function () {
      console.log('showLink')
      this.$refs.dlgLink.open()
    },
    showLinkCompany: function () {
      console.log('showLink')
      this.$refs.dlgLinkCompany.open()
    },
    onLinkCompany: function (item) {
      console.log('onLinkCompany', item)
      Vue.prototype.$api.linkDeviceToCompany(this.deviceGuid, item, this.reload)
    },
    onLink: function (item) {
      console.log('onLink', item)
      Vue.prototype.$api.linkPlayListToDevice(item, this.deviceGuid, this.reload)
    },
    getLabelPlaylist: function () {
      if (this.playList) {
        return 'Playlist gewählt ' + this.playList.name
      }
      return 'Playlist zuweisen'
    },
    onGetCompany: function (data) {
      this.company = data
      if (data) this.cpName = data.name
    },
    onGetPlaylist: function (data) {
      this.playList = data
      if (data) this.plName = data.name
    },
    onGetApps: function (data) {
      this.appsList = data
    },
    reload: function () {
      console.log('reload previe')
      Vue.prototype.$api.loadDevice(this.deviceGuid, this.onGetData)
      this.$refs.wd.reload(this.device,this.companyId)
    }
  },
  data () {
    return {
      uploadConfig: {
        uploadUrl: '',
        jQueryDivName: '#uploadCenter'
      },
      progress: 0,
      appsList: [],
      tab: null,
      tagList: [],
      company: null,
      playList: null,
      formData: {
        name: '',
        screenNumber: '',
        owner: '',
        playlist: '',
        phone: '',
        create: '',
        orientation: '',
        changed: ''
      },
      tag: '',
      tagac: '',
      plName: '',
      cpName: '',
      deviceGuid: '',
      tags: [],
      orientList: [
        {
          key: 'vertical',
          title: 'Vertikal'
        },
        {
          key: 'horizontal',
          title: 'Horizontal'
        }
      ],
      statusList: [
        {
          key: 'NEW',
          title: 'Neu'
        },
        {
          key: 'ACTIVE',
          title: 'Aktiv'
        }
      ],

    }
  },
  mounted () {
    this.deviceGuid = this.$route.params.deviceGuid
    Vue.prototype.$api.loadApps(this.onGetApps)
    this.reload()
  }
}
</script>

<style scoped>

</style>
